export const Image = ({blok}) => {
  const {height, width, alt, image} = blok;

  return <img src={image.filename} alt={alt} style={{height, width}} />;
};
